// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"Img_fadeIn__2th1r","container":"Img_container__MfUcM","image":"Img_image__C4ftI"};